module.exports = __webpack_public_path__ + "img/moose.bf0a4b9b.jpg";